/**
 * Registro central de stickers personalizables.
 *
 * Cada país expone un objeto con su lista de stickers editables. Para añadir
 * un nuevo país basta con crear un archivo `<country>.js` y registrarlo aquí.
 * Los consumidores no deben importar los archivos de país directamente: usar
 * los helpers que se exportan abajo.
 */

import japan from "./japan";

const COUNTRIES = [japan];

const byId = COUNTRIES.reduce((acc, c) => {
	acc[c.id] = c;
	return acc;
}, {});

export const getCustomStickerCountries = () =>
	COUNTRIES.map(({ stickers, ...meta }) => ({
		...meta,
		stickerCount: stickers.length,
	}));

export const getCustomStickerCountry = (countryId) => byId[countryId] || null;

export const getCustomSticker = (countryId, stickerId) => {
	const country = byId[countryId];
	if (!country) return null;
	return country.stickers.find((s) => s.id === stickerId) || null;
};

export const DEFAULT_COUNTRY_ID = japan.id;

export default {
	getCustomStickerCountries,
	getCustomStickerCountry,
	getCustomSticker,
	DEFAULT_COUNTRY_ID,
};
